import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { walletServices } from '../../services/WalletServices';

const UserWalletInfo = () => {
  const { userId } = useParams();

  const [wallet, setWallet] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total_pages: 1,
  });
  const [loading, setLoading] = useState(false);

  const fetchWalletInfo = async (page = 1) => {
    try {
      setLoading(true);
      const params = { page, limit: pagination.per_page };
      const response = await walletServices.userWalletInfo(userId, params);

      const data = response.data?.data;
      if (data) {
        setWallet(data.wallet);
        setTransactions(data.transactions.data);
        setPagination(data.transactions.pagination);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to fetch wallet info');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWalletInfo(pagination.current_page);
  }, [userId]);

  const handlePageChange = (page) => {
    fetchWalletInfo(page);
  };

  const columns = [
    {
      name: 'Date',
      selector: (row) => new Date(row.created_at).toLocaleDateString(),
      sortable: true,
    },
    {
      name: 'Transaction Type',
      selector: (row) => row.transaction_type || 'N/A',
      sortable: true,
    },
    {
      name: 'Amount',
      selector: (row) => `$${row.amount}`,
      sortable: true,
    },
    {
      name: 'Plan',
      selector: (row) => row.plan_id?.category || 'N/A',
      sortable: true,
    },
    {
      name: 'Description',
      selector: (row) => row.description || '-',
      sortable: false,
      grow: 2,
    },
  ];

  return (
    <div className="container mt-4">
      <h3>User Wallet Summary</h3>

      {wallet ? (
        <div className="card mb-4">
          <div className="card-body">
            <h5 className="card-title">{wallet.user.fullName} ({wallet.user.email})</h5>
            <p><strong>Balance:</strong> ${wallet.balance}</p>
            <p><strong>Total Earned:</strong> ${wallet.total_earned}</p>
            <p><strong>Total Spent:</strong> ${wallet.total_spent}</p>
            <p><strong>Created:</strong> {new Date(wallet.created_at).toLocaleDateString()}</p>
          </div>
        </div>
      ) : (
        <p>Loading wallet data...</p>
      )}

      <h4>Wallet Transactions</h4>
      <div className="card">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={transactions}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={pagination.total_records}
            paginationPerPage={pagination.per_page}
            paginationDefaultPage={pagination.current_page}
            onChangePage={handlePageChange}
            highlightOnHover
            noDataComponent="No transactions found"
          />
        </div>
      </div>
    </div>
  );
};

export default UserWalletInfo;
